import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

interface ConfirmArrivalInventoryQtyProps {
  /** The figure the form holds and the API receives — always inventory units. */
  quantity: number;
  /** `ltuTypeDescription`, never the bundle type. */
  unitLabel: string;
  className?: string;
}

/**
 * The inventory-unit figure standing behind a handling-unit one.
 *
 * Handling units are a calculator, not the record: RITA is accountable to the
 * partner in inventory units, a bundle count can be fractional, and
 * `toInventoryUnits` rounds on the way into the form. Without this the operator
 * confirms a number that appears nowhere on screen — so in handling mode every
 * quantity carries the inventory figure it actually stands for.
 */
export function ConfirmArrivalInventoryQty({ quantity, unitLabel, className }: ConfirmArrivalInventoryQtyProps) {
  const { t } = useTranslation();

  return (
    <span className={cn('block text-xs tabular-nums text-muted-foreground', className)}>
      {t('receive.confirm.inInventoryUnits', '= {{qty}} {{unit}}', { qty: quantity, unit: unitLabel })}
    </span>
  );
}
